import EmploymentTypeDetail from './EmploymentTypeDetail';

export default EmploymentTypeDetail;
